var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7333 1.57499C10.9647 1.83318 11.042 2.19465 10.9364 2.52491L9.99904 5.45672L8.13734 4.86149L8.50591 3.7087C5.80835 4.84708 3.78086 7.26471 3.18503 10.2L1.26955 9.81115C2.14078 5.51915 5.51915 2.14078 9.81115 1.26955C10.1509 1.20058 10.5018 1.31681 10.7333 1.57499ZM20.2913 8.50591C19.1529 5.80835 16.7353 3.78086 13.8 3.18503L14.1888 1.26955C18.4809 2.14078 21.8592 5.51915 22.7304 9.81115C22.7994 10.1509 22.6832 10.5018 22.425 10.7333C22.1668 10.9647 21.8053 11.042 21.4751 10.9364L18.5433 9.99904L19.1385 8.13734L20.2913 8.50591ZM1.57499 13.2667C1.83318 13.0353 2.19465 12.958 2.52491 13.0636L5.45672 14.001L4.86149 15.8627L3.7087 15.4941C4.84708 18.1917 7.2647 20.2191 10.2 20.815L9.81115 22.7304C5.51915 21.8592 2.14079 18.4809 1.26955 14.1889C1.20058 13.8491 1.31681 13.4982 1.57499 13.2667ZM15.4941 20.2913C18.1916 19.1529 20.2191 16.7353 20.815 13.8L22.7304 14.1889C21.8592 18.4809 18.4808 21.8592 14.1888 22.7304C13.8491 22.7994 13.4982 22.6832 13.2667 22.425C13.0353 22.1668 12.958 21.8053 13.0636 21.4751L14.001 18.5433L15.8627 19.1385L15.4941 20.2913Z",
    fill: "#A1ABB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5C12 7.5 8 10 8 12.7551C8 14.6012 9.51472 16.5 12 16.5C14.4853 16.5 16 14.6012 16 12.7551C16 10 12 7.5 12 7.5Z",
    fill: "#A1ABB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco4);
export default __webpack_public_path__ + "static/media/ico-4.8bf5753fc9f56480ec3f733938622cdd.svg";
export { ForwardRef as ReactComponent };